import React, { useState, useEffect, useRef } from "react";
import { Fragment } from "react";
import { Link } from "react-router-dom";
const SubMenu = ({
    to,
    topic,
    className,
    list_sub_manu,
    val,
    key,
    c_key,
    isCollapse,
    setisCollapse,
    ActiveKeySubmenu,
    setActiveKeySubmenu,
    setListSubMenu,
}) => {
    const [IconSwap, setIconSwap] = useState(false);
    const submenuRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (submenuRef.current && !submenuRef.current.contains(event.target)) {
                setisCollapse(true);
                setActiveKeySubmenu(null);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [submenuRef, setisCollapse, setActiveKeySubmenu]);

    useEffect(() => {
        if (c_key == ActiveKeySubmenu && isCollapse == false) {
            setIconSwap(true);
        } else if (c_key != ActiveKeySubmenu) {
            setIconSwap(false);
        }

        return () => { };
    }, [ActiveKeySubmenu]);

    const OnClickSubmenu = () => {
        if (c_key === ActiveKeySubmenu) {
            setisCollapse(true);
            setActiveKeySubmenu(null);
        } else {
            setListSubMenu(list_sub_manu);
            setisCollapse(false);
            setActiveKeySubmenu(c_key);
        }
        return;
    };

    const handleUlMouseLeave = () => {
        setisCollapse(true);
        setActiveKeySubmenu(null);
    };

    return (
        <Fragment>
            <li
                className={`${c_key === ActiveKeySubmenu
                    ? "text-[#083AA9]"
                    : "text-black"
                    }   hover:text-[#083AA9]  pl-4 pr-1 mx-1 text-sm lg:text-md xl:text-xl font-medium
                    hover:font-medium cursor-pointer no-underline hover:underline underline-offset-4 group`}
                onClick={OnClickSubmenu}
                onMouseLeave={handleUlMouseLeave}
            >
                <label className="flex cursor-pointer">
                    {topic}
                    {/* &nbsp; */}
                    <i
                        className={`fas fa-lg scale-110 fa-caret-${IconSwap == true ? "up" : "down"
                            } items-center flexs no-underline hidden`}
                    ></i>
                </label>
                {c_key === ActiveKeySubmenu && (
                    <>
                        <ul className="absolute pt-2 z-20 p-3 bg-gradient-to-r from-[#083AA9] to-[#0E4DD8] rounded-lg shadow shadow-custom-500/20"
                            onMouseLeave={handleUlMouseLeave}
                        >
                            {list_sub_manu &&
                                list_sub_manu &&
                                list_sub_manu[0] &&
                                list_sub_manu.map((valsub, c) => {
                                    return (
                                        <li key={c} className="hover:bg-white hover:rounded-md">
                                            <a
                                                href={valsub.url}
                                                target={`_self`}
                                                className={classNames(
                                                    ` text-white  mx-1 p-1 items-center hover:font-semibold
                                                    hover:text-[#002FD4]
                                                    text-xs md:text-sm lg:text-base xl:text-base
                                                    font-base cursor-pointer no-underline flex
                                                    `,
                                                    className
                                                )}
                                            >
                                                ๐ {valsub.description}
                                            </a>
                                        </li>
                                    );
                                })}
                        </ul>
                    </>
                )}
            </li>
        </Fragment>
    );
};

function classNames(...classes) {
    return classes.filter(Boolean).join(" ");
}

export default SubMenu;
